import React from 'react';
import { plural } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';

import StarSitter from '@rover/icons/svg/star-sitter.svg';
import { Flex, Heading, Paragraph } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

type Props = {
  providerName: string;
  isPluralAccount?: boolean;
};

const StarSitterCallout = ({ providerName, isPluralAccount = false }: Props): JSX.Element => {
  const { t } = useLingui();
  const theme = useTheme();
  return (
    <Flex
      sx={{ pt: ['0px', '0px', '6x'], pb: ['40px', '40x', '12x'] }}
      alignItems="start"
      alignSelf="stretch"
      borderBottom={`1px solid ${theme.colors.separator.primary}`}
      data-testid="star-sitter-callout"
    >
      <StarSitter width="48px" height="48px" fill={theme.colors.interactive_link.secondary_base} />
      <Flex flexDirection="column" alignItems="start" flex="1 0 0" pl="4x">
        <Heading pb="2x" mb="0x">
          {t({
            message: plural(isPluralAccount ? 2 : 1, {
              one: `${providerName} has Star Sitter status`,
              other: `${providerName} have Star Sitter status`,
            }),
          })}
        </Heading>
        <Paragraph mb="0x" webProps={{ maxWidth: '100%' }}>
          {t`The Star Sitter program highlights responsive sitters who deliver highly rated care and have a history of listing accurate availability and preferences, making it easier for pet parents to find the best care for their pets.`}
        </Paragraph>
      </Flex>
    </Flex>
  );
};

export default StarSitterCallout;
